import { BaseService } from "./base.service";

export interface Lidmaatschap {
  MembershipNumber: string;
  StartDate: Date;
  ResignDate?: Date | null;
  EndDate?: Date | null;
  RightsDate?: Date | null;
  PaymentMethod: string;
  ContributionAmount: number;
  IsActive: boolean;
}

export class LidmaatschapService extends BaseService {
  constructor() {
    super('/api/lidmaatschap/v3');
  }

  public async GetLidmaatschapData<T>(memberGuid:string): Promise<T> {
    return this.Get<T>(`/${memberGuid}`);
  }
}